import React from "react";
import styles from "../styles/helpSettings.module.css";

export default function HelpSettings() {
  return (
    <section className={styles.helpPanel} aria-label="Help and support resources">
      <section className={styles.helpSection}>
        <h5>First time here?</h5>
        <p>Welcome! There&apos;s lots to see and do here so be sure to get up to speed via our support hub.</p>
        <a
          href="https://aka.ms/ChefsMenuSupportHub"
          className={styles.helpLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open Chef Menu Support Hub in a new tab"
        >
          Open Chef Menu Support Hub
        </a>
      </section>

      <section className={styles.helpSection}>
        <h5>Not seeing something you need?</h5>
        <p>Get in touch with our Finance Assistant Agent to help answer your questions.</p>
        <a
          href="https://aka.ms/fafinsup"
          className={styles.helpLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open Finance Assistant Agent in a new tab"
        >
          Open Finance Assistant Agent
        </a>
      </section>

      <section className={styles.helpSection}>
        <h5>Found a Bug?</h5>
        <p>Let us know if you found something broken!</p>
        <a
          href="https://aka.ms/fafinsup"
          className={styles.helpLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open Finance Assistant Agent in a new tab"
        >
          Open Finance Assistant Agent
        </a>
      </section>
    </section>
  );
}
